'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgExportSolid = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.47 18.47c-.26.25-.67.24-.92-.02a.649.649 0 0 1 .02-.92.649.649 0 0 1 1.1.47c0 .18-.08.35-.2.47zm2.66 0c-.26.25-.67.24-.92-.02a.649.649 0 0 1 .02-.92.649.649 0 0 1 1.1.47c0 .18-.07.35-.2.47zm1.54-2.8c0-.55-.45-1-1-1h-4.84l-1.42 1.42c-.78.78-2.05.78-2.83 0l-1.4-1.42H4.34c-.55 0-1 .45-1 1V19c0 .55.45 1 1 1h15.32c.55 0 1-.45 1-1v-3.34l.01.01zm-4-6.33H14V4.67a.692.692 0 0 0-.68-.67h-2.66a.69.69 0 0 0-.67.67v4.66H7.34a.628.628 0 0 0-.62.41c-.13.25-.06.55.15.73l4.66 4.66c.25.26.66.27.92.02l.02-.02 4.66-4.66c.21-.18.28-.48.15-.73a.62.62 0 0 0-.63-.41l.02.01z",
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke"
})));

exports["default"] = SvgExportSolid;
